/** Paper UI and vector stamps; dynamic tool/name labels are included explicitly. */
export const SCRAPBOOK: Record<string, string> = {
  'Draw · Customize · Battle · Share': 'วาด · ปรับแต่ง · ต่อสู้ · แบ่งปัน',
  '→ New Legends!': '→ สร้างตำนานใหม่!',
  'Refresh friends': 'โหลดรายชื่อเพื่อนใหม่',
  'Prototype UI ☺': 'หน้าจอทดลอง ☺',
  'Design monsters and challenge friends ☺': 'ออกแบบมอนสเตอร์ แล้วท้าเพื่อนมาสู้ ☺',
  'Colour palette': 'ชุดสีเทียน',
  'Stamps': 'ตราวาด',
  'Stamp': 'ตราวาด',
  'Stamp: {name}': 'ตราวาด: {name}',
  'More stamps': 'ดูตราวาดเพิ่มเติม',
  'Use stamps to add cool parts!': 'ใช้ตราวาดเพิ่มส่วนเจ๋ง ๆ ได้เลย!',
  "Silly? Scary? Heroic? It's up to you!": 'ตลก? น่ากลัว? กล้าหาญ? คุณเลือกได้เลย!',
  'Your monsters. Your stories. Share the fun!': 'มอนสเตอร์ของคุณ เรื่องราวของคุณ แบ่งปันความสนุก!',
  'Tools': 'เครื่องมือ',
  'Color': 'สี',
  'Undo': 'ย้อนกลับ',
  'More tools': 'เครื่องมือเพิ่มเติม',
  '{stat} {change}': '{stat} {change}',
  '{skill} ({cost} pts)': '{skill} ({cost} แต้ม)',
  'Monster Settings': 'ตั้งค่ามอนสเตอร์',
  'Custom rewards': 'กำหนดรางวัลเอง',
  'EXP & coins': 'ค่าประสบการณ์และเหรียญ',
  'EXP only': 'ค่าประสบการณ์เท่านั้น',
  'Coins only': 'เหรียญเท่านั้น',
  'No rewards': 'ไม่มีรางวัล',
  '{exp} EXP · {coins} coins': '{exp} EXP · {coins} เหรียญ',
  'Sir Scribbles': 'อัศวินขีดเขียน',
  'Captain Crumbs': 'กัปตันเศษยางลบ',
  'Wobbly Waffle': 'วาฟเฟิลโยกเยก',
  'Professor Puddle': 'ศาสตราจารย์แอ่งน้ำ',
  'Doodle Dragon': 'มังกรขีดเขียน',
  'Crayon Goblin': 'ก็อบลินสีเทียน',
  'Sleepy Spark': 'ประกายขี้เซา',
  'King Noodle': 'ราชาบะหมี่',
  'Random monster name': 'สุ่มชื่อมอนสเตอร์',
  'Advanced': 'ขั้นสูง',
  'Share & Challenge': 'แบ่งปันและท้าสู้',
  'Save to Notebook': 'บันทึกลงสมุด',
  'Share with Friends': 'แบ่งปันกับเพื่อน',
  'Create Challenge Room': 'สร้างห้องท้าสู้',
  'Try your monster against AI!': 'ลองให้มอนสเตอร์ของคุณสู้กับ AI!',
  'Keep it in your collection!': 'เก็บไว้ในคอลเลกชันของคุณ!',
  'Let your friends draw and battle it!': 'ให้เพื่อนวาดและมาสู้กัน!',
  'Set up a room and invite friends!': 'ตั้งห้องแล้วชวนเพื่อนเข้ามา!',
  'Friends & Challenges': 'เพื่อนและการท้าสู้',
  'Recent Challenges': 'การท้าสู้ล่าสุด',
  'Challenge me!': 'มาท้าฉันสิ!',
  'Your next challenge starts a new story!': 'การท้าสู้ครั้งถัดไปจะเริ่มเรื่องราวใหม่!',
  'Connect in Friends to find your drawing buddies.': 'เชื่อมต่อในหน้าเพื่อนเพื่อพบเพื่อนนักวาด',
  'Add a friend in your notebook and share the fun!': 'เพิ่มเพื่อนในสมุด แล้วแบ่งปันความสนุก!',
  'Friends are taking a pencil break. Try again in your notebook.': 'เพื่อนกำลังพักดินสอ ลองใหม่ในสมุดของคุณ',
  'Friends make stronger legends!': 'เพื่อนทำให้ตำนานแข็งแกร่งขึ้น!',
  'Your Monster': 'มอนสเตอร์ของคุณ',
  'Lv. {n}': 'เลเวล {n}',
  'Monsters erase… But legends are drawn!': 'มอนสเตอร์ถูกลบได้… แต่ตำนานวาดขึ้นใหม่ได้!',
  'Guard / Focus': 'ป้องกัน / ตั้งสมาธิ',
  'Star': 'ดาว',
  'Fire': 'เปลวไฟ',
  'Rock': 'ค้อน',
  'Wing': 'ปีก',
  'Horn': 'เขา',
  'Crown': 'มงกุฎ',
  'Paw': 'อุ้งเท้า',
  'Skull': 'กะโหลก',
  'Sparkle': 'ประกาย',
  'Mountain': 'ภูเขา',
  'Cloud': 'เมฆ',
};
